import { HowToWorkPage } from "../HowToWorkPage"
import { sellerConfig } from "../configs/seller.config"

export function HowToWorkSeller() {
    return <HowToWorkPage config={sellerConfig} />
}
